import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { LocalStorage } from '@vectord/utils';

const lsInstance = LocalStorage.getInstance('store.activities.columnConfig');

export interface EditableColumnConfig {
  dataIndex: string;
  schemaName: string;
  attributeName: string;
  isChecked: boolean;
}

export interface ColumnConfig {
  order: Record<string, string[]>;
}

export const initialState: ColumnConfig = {
  order: {},
};

const savedConfig: ColumnConfig = lsInstance?.config;

export const columnConfigSlice = createSlice({
  name: 'columnConfig',
  initialState: { ...initialState, ...savedConfig },
  reducers: {
    setOrder: (state, action: PayloadAction<{
      activityId: string;
      order: string[];
    }>) => {
      const { activityId, order } = action.payload;
      state.order[activityId] = order;
    },
    removeColumns: (state, action: PayloadAction<{
      activityId: string;
      dataIndexes: string[];
    }>) => {
      const { activityId, dataIndexes } = action.payload;
      state.order[activityId] = state.order[activityId]?.filter((value) => !dataIndexes.includes(value)) ?? [];
    },
    setOrderFromConfig: (state, action: PayloadAction<{
      activityId: string;
      config: EditableColumnConfig[];
    }>) => {
      const { activityId, config } = action.payload;

      const order = state.order[activityId] ?? [];
      config.forEach((item) => {
        if (item.isChecked && !order.includes(item.dataIndex)) {
          order.push(item.dataIndex);
        } else if (!item.isChecked && order.includes(item.dataIndex)) {
          order.splice(order.indexOf(item.dataIndex), 1);
        }
      });
      state.order[activityId] = order;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      (action) => action.type.startsWith('columnConfig/'),
      (state) => { lsInstance.config = state; },
    );
  },
});

export const {
  setOrder,
  setOrderFromConfig,
  removeColumns,
} = columnConfigSlice.actions;

export default columnConfigSlice.reducer;
